import { connect } from 'react-redux';
import * as R from 'ramda';
import LastStep2 from './LastStep2';
import { getStoreValueByProp } from '../../store/sequencingWizardSlice';

const mapState = R.applySpec({
  loading: getStoreValueByProp(['locationsLoading']),
});

export default connect(mapState, {})(LastStep2);
